import DashboardSection from './dashboard-section';
import ProductRatingsPieChart from './product-ratings-pie-chart';

interface ProductRatingsBreakdownInterface {
  productEmissionsCategoryBreakdown: {
    emissionsCategory: string;
    numProducts: number;
  }[];
  averageEmissionsCategory: string;
  collectionUuid?: string;
}

const ProductRatingsBreakdown = ({
  productEmissionsCategoryBreakdown,
  averageEmissionsCategory,
  collectionUuid,
}: ProductRatingsBreakdownInterface) => {
  const chartData = productEmissionsCategoryBreakdown?.map((category) => {
    return {
      category: category.emissionsCategory,
      items: category.numProducts,
      fill: `var(--rating-${category.emissionsCategory.toLowerCase()})`,
    };
  });

  return (
    <div data-testid="breakdown-of-product-ratings">
      <DashboardSection
        title="Breakdown of Product Ratings"
        tooltipContent="Breakdown of Product Ratings"
      >
        <div className="flex h-[350px] w-full items-center justify-center rounded-md bg-gray-00">
          <ProductRatingsPieChart
            data={chartData}
            averageEmissionsCategory={averageEmissionsCategory}
            collectionUuid={collectionUuid}
          />
        </div>
      </DashboardSection>
    </div>
  );
};

export default ProductRatingsBreakdown;
